export default "__VITE_ASSET__hUICWwPc__"